import { default as _91_46_46_46slug_93XOh4cis8EcMeta } from "/app/src/pages/[...slug].vue?macro=true";
import { default as indexfkgfx7juYHMeta } from "/app/src/pages/airdrop-kyc/index.vue?macro=true";
import { default as _91id_93ofu0wh0lJKMeta } from "/app/src/pages/airdrop/[id].vue?macro=true";
import { default as index7SMJCOTeEaMeta } from "/app/src/pages/airdrop/index.vue?macro=true";
import { default as indexbKBo0yz0H6Meta } from "/app/src/pages/api-management/index.vue?macro=true";
import { default as index5KyfHsOfJiMeta } from "/app/src/pages/app-customer-service/index.vue?macro=true";
import { default as _91_91currency_93_93Prerodpw9zMeta } from "/app/src/pages/assets/deposit/[[currency]].vue?macro=true";
import { default as indexUWbRCXitOXMeta } from "/app/src/pages/assets/transfer/index.vue?macro=true";
import { default as _91_91currency_93_93YwNLBUviuqMeta } from "/app/src/pages/assets/withdraw/[[currency]].vue?macro=true";
import { default as indexhSyFSYWir9Meta } from "/app/src/pages/assets/withdraw/address-management/index.vue?macro=true";
import { default as assets4zfvwWlTe5Meta } from "/app/src/pages/assets.vue?macro=true";
import { default as indexuyUvU5U3spMeta } from "/app/src/pages/card-detail/index.vue?macro=true";
import { default as index2AHgTygd1oMeta } from "/app/src/pages/contest/[id]/index.vue?macro=true";
import { default as indexJ0xFJBJiVyMeta } from "/app/src/pages/contest/index.vue?macro=true";
import { default as indexxpYBPsDnj5Meta } from "/app/src/pages/download/index.vue?macro=true";
import { default as index0ezZMUVqHOMeta } from "/app/src/pages/forgot/index.vue?macro=true";
import { default as _91_91symbol_93_93WnrzTlR79AMeta } from "/app/src/pages/futures/[[symbol]].vue?macro=true";
import { default as indexPDYNSawuwOMeta } from "/app/src/pages/futures/rules/index.vue?macro=true";
import { default as indexdPwi6hPdMfMeta } from "/app/src/pages/index.vue?macro=true";
import { default as indexvEpHzRgGgAMeta } from "/app/src/pages/inform/index.vue?macro=true";
import { default as indexAtagqkgvjwMeta } from "/app/src/pages/invite-friends/index.vue?macro=true";
import { default as indexfJYi4k8bljMeta } from "/app/src/pages/joinUs/index.vue?macro=true";
import { default as _91id_93OhUTyKkkeRMeta } from "/app/src/pages/launchpool/[id].vue?macro=true";
import { default as index1j4fRF4HvkMeta } from "/app/src/pages/launchpool/index.vue?macro=true";
import { default as indexh5BmfFRW9eMeta } from "/app/src/pages/launchpool/pledge/index.vue?macro=true";
import { default as indexZdSrGQcyeQMeta } from "/app/src/pages/launchpool/rewards/index.vue?macro=true";
import { default as indexrV8sHAWlIjMeta } from "/app/src/pages/links/index.vue?macro=true";
import { default as index3EIzGsyygqMeta } from "/app/src/pages/log-in/index.vue?macro=true";
import { default as indexcFdsYSJC29Meta } from "/app/src/pages/markets/favorite/index.vue?macro=true";
import { default as indexdBfkojnUAAMeta } from "/app/src/pages/markets/futures/index.vue?macro=true";
import { default as indexGw80X24YQfMeta } from "/app/src/pages/markets/index.vue?macro=true";
import { default as index98zLGNrXvtMeta } from "/app/src/pages/markets/spot/index.vue?macro=true";
import { default as markets1Wulb56LB7Meta } from "/app/src/pages/markets.vue?macro=true";
import { default as _91_91type_93_93FSdg2R6u0XMeta } from "/app/src/pages/my/orders/future/[[type]].vue?macro=true";
import { default as _91_91type_93_93GfX7jsJtwqMeta } from "/app/src/pages/my/orders/spot/[[type]].vue?macro=true";
import { default as indexIxukrxA3seMeta } from "/app/src/pages/my/wallet/future/index.vue?macro=true";
import { default as index1OXJuG8SB6Meta } from "/app/src/pages/my/wallet/index.vue?macro=true";
import { default as index420d5FXycJMeta } from "/app/src/pages/my/wallet/spot/index.vue?macro=true";
import { default as myX0IidJ4wjZMeta } from "/app/src/pages/my.vue?macro=true";
import { default as indexMJaNOt3E4RMeta } from "/app/src/pages/node/record/index.vue?macro=true";
import { default as indexZZTBKuA4nFMeta } from "/app/src/pages/partner/index.vue?macro=true";
import { default as indexYt4ISFXuA2Meta } from "/app/src/pages/privacy-portal/index.vue?macro=true";
import { default as indexuwjnwDioWQMeta } from "/app/src/pages/referral/index.vue?macro=true";
import { default as indexYChQVes8pRMeta } from "/app/src/pages/sign-up/index.vue?macro=true";
import { default as _91_91symbol_93_93Q7ccl8p29CMeta } from "/app/src/pages/spot/[[symbol]].vue?macro=true";
import { default as indexP7iaSVhb9eMeta } from "/app/src/pages/terms/index.vue?macro=true";
import { default as indexvxEWUpzYWmMeta } from "/app/src/pages/token-listing-apply/index.vue?macro=true";
import { default as invitetvbsJ1rEURMeta } from "/app/src/pages/token-listing-apply/invite.vue?macro=true";
import { default as indexAXkeIboLlqMeta } from "/app/src/pages/user/index.vue?macro=true";
import { default as usermBqipyQ407Meta } from "/app/src/pages/user.vue?macro=true";
export default [
  {
    name: "slug___ko",
    path: "/ko/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___ja",
    path: "/ja/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___zh-hant",
    path: "/zh-hant/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___en___default",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___en",
    path: "/en/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___es",
    path: "/es/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___zh-CN",
    path: "/zh-CN/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___it",
    path: "/it/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___ru",
    path: "/ru/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___vi",
    path: "/vi/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___id",
    path: "/id/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___km",
    path: "/km/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___hi",
    path: "/hi/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___th",
    path: "/th/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___fr",
    path: "/fr/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "slug___ar",
    path: "/ar/:slug(.*)*",
    meta: _91_46_46_46slug_93XOh4cis8EcMeta || {},
    component: () => import("/app/src/pages/[...slug].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___ko",
    path: "/ko/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___ja",
    path: "/ja/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___zh-hant",
    path: "/zh-hant/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___en___default",
    path: "/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___en",
    path: "/en/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___es",
    path: "/es/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___zh-CN",
    path: "/zh-CN/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___it",
    path: "/it/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___ru",
    path: "/ru/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___vi",
    path: "/vi/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___id",
    path: "/id/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___km",
    path: "/km/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___hi",
    path: "/hi/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___th",
    path: "/th/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___fr",
    path: "/fr/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-kyc___ar",
    path: "/ar/airdrop-kyc",
    meta: indexfkgfx7juYHMeta || {},
    component: () => import("/app/src/pages/airdrop-kyc/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___ko",
    path: "/ko/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___ja",
    path: "/ja/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___zh-hant",
    path: "/zh-hant/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___en___default",
    path: "/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___en",
    path: "/en/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___es",
    path: "/es/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___zh-CN",
    path: "/zh-CN/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___it",
    path: "/it/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___ru",
    path: "/ru/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___vi",
    path: "/vi/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___id",
    path: "/id/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___km",
    path: "/km/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___hi",
    path: "/hi/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___th",
    path: "/th/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___fr",
    path: "/fr/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop-id___ar",
    path: "/ar/airdrop/:id()",
    meta: _91id_93ofu0wh0lJKMeta || {},
    component: () => import("/app/src/pages/airdrop/[id].vue").then(m => m.default || m)
  },
  {
    name: "airdrop___ko",
    path: "/ko/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___ja",
    path: "/ja/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___zh-hant",
    path: "/zh-hant/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___en___default",
    path: "/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___en",
    path: "/en/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___es",
    path: "/es/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___zh-CN",
    path: "/zh-CN/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___it",
    path: "/it/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___ru",
    path: "/ru/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___vi",
    path: "/vi/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___id",
    path: "/id/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___km",
    path: "/km/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___hi",
    path: "/hi/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___th",
    path: "/th/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___fr",
    path: "/fr/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "airdrop___ar",
    path: "/ar/airdrop",
    meta: index7SMJCOTeEaMeta || {},
    component: () => import("/app/src/pages/airdrop/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___ko",
    path: "/ko/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___ja",
    path: "/ja/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___zh-hant",
    path: "/zh-hant/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___en___default",
    path: "/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___en",
    path: "/en/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___es",
    path: "/es/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___zh-CN",
    path: "/zh-CN/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___it",
    path: "/it/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___ru",
    path: "/ru/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___vi",
    path: "/vi/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___id",
    path: "/id/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___km",
    path: "/km/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___hi",
    path: "/hi/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___th",
    path: "/th/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___fr",
    path: "/fr/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "api-management___ar",
    path: "/ar/api-management",
    component: () => import("/app/src/pages/api-management/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___ko",
    path: "/ko/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___ja",
    path: "/ja/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___zh-hant",
    path: "/zh-hant/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___en___default",
    path: "/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___en",
    path: "/en/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___es",
    path: "/es/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___zh-CN",
    path: "/zh-CN/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___it",
    path: "/it/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___ru",
    path: "/ru/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___vi",
    path: "/vi/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___id",
    path: "/id/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___km",
    path: "/km/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___hi",
    path: "/hi/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___th",
    path: "/th/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___fr",
    path: "/fr/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "app-customer-service___ar",
    path: "/ar/app-customer-service",
    meta: index5KyfHsOfJiMeta || {},
    component: () => import("/app/src/pages/app-customer-service/index.vue").then(m => m.default || m)
  },
  {
    name: "assets___ko",
    path: "/ko/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___ko",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___ko",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___ko",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___ko",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___ja",
    path: "/ja/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___ja",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___ja",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___ja",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___ja",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___zh-hant",
    path: "/zh-hant/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___zh-hant",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___zh-hant",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___zh-hant",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___zh-hant",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___en___default",
    path: "/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___en___default",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___en___default",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___en___default",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___en___default",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___en",
    path: "/en/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___en",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___en",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___en",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___en",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___es",
    path: "/es/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___es",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___es",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___es",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___es",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___zh-CN",
    path: "/zh-CN/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___zh-CN",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___zh-CN",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___zh-CN",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___zh-CN",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___it",
    path: "/it/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___it",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___it",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___it",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___it",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___ru",
    path: "/ru/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___ru",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___ru",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___ru",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___ru",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___vi",
    path: "/vi/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___vi",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___vi",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___vi",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___vi",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___id",
    path: "/id/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___id",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___id",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___id",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___id",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___km",
    path: "/km/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___km",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___km",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___km",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___km",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___hi",
    path: "/hi/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___hi",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___hi",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___hi",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___hi",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___th",
    path: "/th/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___th",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___th",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___th",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___th",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___fr",
    path: "/fr/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___fr",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___fr",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___fr",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___fr",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "assets___ar",
    path: "/ar/assets",
    meta: assets4zfvwWlTe5Meta || {},
    component: () => import("/app/src/pages/assets.vue").then(m => m.default || m),
    children: [
  {
    name: "assets-deposit-currency___ar",
    path: "deposit/:currency?",
    component: () => import("/app/src/pages/assets/deposit/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-transfer___ar",
    path: "transfer",
    meta: indexUWbRCXitOXMeta || {},
    component: () => import("/app/src/pages/assets/transfer/index.vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-currency___ar",
    path: "withdraw/:currency?",
    component: () => import("/app/src/pages/assets/withdraw/[[currency]].vue").then(m => m.default || m)
  },
  {
    name: "assets-withdraw-address-management___ar",
    path: "withdraw/address-management",
    meta: indexhSyFSYWir9Meta || {},
    component: () => import("/app/src/pages/assets/withdraw/address-management/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "card-detail___ko",
    path: "/ko/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___ja",
    path: "/ja/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___zh-hant",
    path: "/zh-hant/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___en___default",
    path: "/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___en",
    path: "/en/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___es",
    path: "/es/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___zh-CN",
    path: "/zh-CN/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___it",
    path: "/it/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___ru",
    path: "/ru/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___vi",
    path: "/vi/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___id",
    path: "/id/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___km",
    path: "/km/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___hi",
    path: "/hi/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___th",
    path: "/th/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___fr",
    path: "/fr/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "card-detail___ar",
    path: "/ar/card-detail",
    meta: indexuyUvU5U3spMeta || {},
    component: () => import("/app/src/pages/card-detail/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___ko",
    path: "/ko/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___ja",
    path: "/ja/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___zh-hant",
    path: "/zh-hant/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___en___default",
    path: "/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___en",
    path: "/en/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___es",
    path: "/es/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___zh-CN",
    path: "/zh-CN/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___it",
    path: "/it/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___ru",
    path: "/ru/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___vi",
    path: "/vi/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___id",
    path: "/id/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___km",
    path: "/km/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___hi",
    path: "/hi/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___th",
    path: "/th/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___fr",
    path: "/fr/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest-id___ar",
    path: "/ar/contest/:id()",
    meta: index2AHgTygd1oMeta || {},
    component: () => import("/app/src/pages/contest/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___ko",
    path: "/ko/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___ja",
    path: "/ja/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___zh-hant",
    path: "/zh-hant/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___en___default",
    path: "/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___en",
    path: "/en/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___es",
    path: "/es/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___zh-CN",
    path: "/zh-CN/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___it",
    path: "/it/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___ru",
    path: "/ru/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___vi",
    path: "/vi/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___id",
    path: "/id/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___km",
    path: "/km/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___hi",
    path: "/hi/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___th",
    path: "/th/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___fr",
    path: "/fr/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "contest___ar",
    path: "/ar/contest",
    meta: indexJ0xFJBJiVyMeta || {},
    component: () => import("/app/src/pages/contest/index.vue").then(m => m.default || m)
  },
  {
    name: "download___ko",
    path: "/ko/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___ja",
    path: "/ja/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___zh-hant",
    path: "/zh-hant/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___en___default",
    path: "/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___en",
    path: "/en/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___es",
    path: "/es/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___zh-CN",
    path: "/zh-CN/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___it",
    path: "/it/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___ru",
    path: "/ru/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___vi",
    path: "/vi/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___id",
    path: "/id/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___km",
    path: "/km/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___hi",
    path: "/hi/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___th",
    path: "/th/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___fr",
    path: "/fr/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "download___ar",
    path: "/ar/download",
    meta: indexxpYBPsDnj5Meta || {},
    component: () => import("/app/src/pages/download/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___ko",
    path: "/ko/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___ja",
    path: "/ja/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___zh-hant",
    path: "/zh-hant/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___en___default",
    path: "/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___en",
    path: "/en/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___es",
    path: "/es/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___zh-CN",
    path: "/zh-CN/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___it",
    path: "/it/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___ru",
    path: "/ru/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___vi",
    path: "/vi/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___id",
    path: "/id/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___km",
    path: "/km/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___hi",
    path: "/hi/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___th",
    path: "/th/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___fr",
    path: "/fr/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "forgot___ar",
    path: "/ar/forgot",
    meta: index0ezZMUVqHOMeta || {},
    component: () => import("/app/src/pages/forgot/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___ko",
    path: "/ko/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___ja",
    path: "/ja/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___zh-hant",
    path: "/zh-hant/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___en___default",
    path: "/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___en",
    path: "/en/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___es",
    path: "/es/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___zh-CN",
    path: "/zh-CN/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___it",
    path: "/it/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___ru",
    path: "/ru/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___vi",
    path: "/vi/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___id",
    path: "/id/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___km",
    path: "/km/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___hi",
    path: "/hi/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___th",
    path: "/th/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___fr",
    path: "/fr/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-symbol___ar",
    path: "/ar/futures/:symbol?",
    meta: _91_91symbol_93_93WnrzTlR79AMeta || {},
    component: () => import("/app/src/pages/futures/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___ko",
    path: "/ko/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___ja",
    path: "/ja/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___zh-hant",
    path: "/zh-hant/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___en___default",
    path: "/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___en",
    path: "/en/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___es",
    path: "/es/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___zh-CN",
    path: "/zh-CN/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___it",
    path: "/it/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___ru",
    path: "/ru/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___vi",
    path: "/vi/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___id",
    path: "/id/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___km",
    path: "/km/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___hi",
    path: "/hi/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___th",
    path: "/th/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___fr",
    path: "/fr/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "futures-rules___ar",
    path: "/ar/futures/rules",
    component: () => import("/app/src/pages/futures/rules/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ja",
    path: "/ja",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh-hant",
    path: "/zh-hant",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en___default",
    path: "/",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___zh-CN",
    path: "/zh-CN",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ru",
    path: "/ru",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___vi",
    path: "/vi",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___id",
    path: "/id",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___km",
    path: "/km",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___hi",
    path: "/hi",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___th",
    path: "/th",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "index___ar",
    path: "/ar",
    meta: indexdPwi6hPdMfMeta || {},
    component: () => import("/app/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___ko",
    path: "/ko/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___ja",
    path: "/ja/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___zh-hant",
    path: "/zh-hant/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___en___default",
    path: "/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___en",
    path: "/en/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___es",
    path: "/es/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___zh-CN",
    path: "/zh-CN/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___it",
    path: "/it/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___ru",
    path: "/ru/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___vi",
    path: "/vi/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___id",
    path: "/id/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___km",
    path: "/km/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___hi",
    path: "/hi/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___th",
    path: "/th/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___fr",
    path: "/fr/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "inform___ar",
    path: "/ar/inform",
    component: () => import("/app/src/pages/inform/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___ko",
    path: "/ko/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___ja",
    path: "/ja/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___zh-hant",
    path: "/zh-hant/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___en___default",
    path: "/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___en",
    path: "/en/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___es",
    path: "/es/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___zh-CN",
    path: "/zh-CN/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___it",
    path: "/it/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___ru",
    path: "/ru/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___vi",
    path: "/vi/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___id",
    path: "/id/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___km",
    path: "/km/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___hi",
    path: "/hi/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___th",
    path: "/th/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___fr",
    path: "/fr/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "invite-friends___ar",
    path: "/ar/invite-friends",
    meta: indexAtagqkgvjwMeta || {},
    component: () => import("/app/src/pages/invite-friends/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___ko",
    path: "/ko/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___ja",
    path: "/ja/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___zh-hant",
    path: "/zh-hant/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___en___default",
    path: "/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___en",
    path: "/en/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___es",
    path: "/es/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___zh-CN",
    path: "/zh-CN/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___it",
    path: "/it/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___ru",
    path: "/ru/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___vi",
    path: "/vi/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___id",
    path: "/id/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___km",
    path: "/km/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___hi",
    path: "/hi/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___th",
    path: "/th/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___fr",
    path: "/fr/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "joinUs___ar",
    path: "/ar/joinUs",
    meta: indexfJYi4k8bljMeta || {},
    component: () => import("/app/src/pages/joinUs/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___ko",
    path: "/ko/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___ja",
    path: "/ja/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___zh-hant",
    path: "/zh-hant/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___en___default",
    path: "/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___en",
    path: "/en/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___es",
    path: "/es/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___zh-CN",
    path: "/zh-CN/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___it",
    path: "/it/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___ru",
    path: "/ru/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___vi",
    path: "/vi/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___id",
    path: "/id/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___km",
    path: "/km/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___hi",
    path: "/hi/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___th",
    path: "/th/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___fr",
    path: "/fr/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool-id___ar",
    path: "/ar/launchpool/:id()",
    meta: _91id_93OhUTyKkkeRMeta || {},
    component: () => import("/app/src/pages/launchpool/[id].vue").then(m => m.default || m)
  },
  {
    name: "launchpool___ko",
    path: "/ko/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___ja",
    path: "/ja/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___zh-hant",
    path: "/zh-hant/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___en___default",
    path: "/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___en",
    path: "/en/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___es",
    path: "/es/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___zh-CN",
    path: "/zh-CN/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___it",
    path: "/it/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___ru",
    path: "/ru/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___vi",
    path: "/vi/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___id",
    path: "/id/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___km",
    path: "/km/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___hi",
    path: "/hi/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___th",
    path: "/th/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___fr",
    path: "/fr/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool___ar",
    path: "/ar/launchpool",
    meta: index1j4fRF4HvkMeta || {},
    component: () => import("/app/src/pages/launchpool/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___ko",
    path: "/ko/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___ja",
    path: "/ja/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___zh-hant",
    path: "/zh-hant/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___en___default",
    path: "/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___en",
    path: "/en/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___es",
    path: "/es/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___zh-CN",
    path: "/zh-CN/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___it",
    path: "/it/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___ru",
    path: "/ru/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___vi",
    path: "/vi/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___id",
    path: "/id/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___km",
    path: "/km/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___hi",
    path: "/hi/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___th",
    path: "/th/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___fr",
    path: "/fr/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-pledge___ar",
    path: "/ar/launchpool/pledge",
    meta: indexh5BmfFRW9eMeta || {},
    component: () => import("/app/src/pages/launchpool/pledge/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___ko",
    path: "/ko/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___ja",
    path: "/ja/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___zh-hant",
    path: "/zh-hant/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___en___default",
    path: "/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___en",
    path: "/en/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___es",
    path: "/es/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___zh-CN",
    path: "/zh-CN/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___it",
    path: "/it/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___ru",
    path: "/ru/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___vi",
    path: "/vi/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___id",
    path: "/id/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___km",
    path: "/km/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___hi",
    path: "/hi/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___th",
    path: "/th/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___fr",
    path: "/fr/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "launchpool-rewards___ar",
    path: "/ar/launchpool/rewards",
    meta: indexZdSrGQcyeQMeta || {},
    component: () => import("/app/src/pages/launchpool/rewards/index.vue").then(m => m.default || m)
  },
  {
    name: "links___ko",
    path: "/ko/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___ja",
    path: "/ja/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___zh-hant",
    path: "/zh-hant/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___en___default",
    path: "/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___en",
    path: "/en/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___es",
    path: "/es/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___zh-CN",
    path: "/zh-CN/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___it",
    path: "/it/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___ru",
    path: "/ru/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___vi",
    path: "/vi/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___id",
    path: "/id/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___km",
    path: "/km/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___hi",
    path: "/hi/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___th",
    path: "/th/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___fr",
    path: "/fr/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "links___ar",
    path: "/ar/links",
    meta: indexrV8sHAWlIjMeta || {},
    component: () => import("/app/src/pages/links/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___ko",
    path: "/ko/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___ja",
    path: "/ja/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___zh-hant",
    path: "/zh-hant/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___en___default",
    path: "/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___en",
    path: "/en/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___es",
    path: "/es/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___zh-CN",
    path: "/zh-CN/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___it",
    path: "/it/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___ru",
    path: "/ru/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___vi",
    path: "/vi/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___id",
    path: "/id/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___km",
    path: "/km/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___hi",
    path: "/hi/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___th",
    path: "/th/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___fr",
    path: "/fr/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: "log-in___ar",
    path: "/ar/log-in",
    meta: index3EIzGsyygqMeta || {},
    component: () => import("/app/src/pages/log-in/index.vue").then(m => m.default || m)
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/ko/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___ko",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___ko",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___ko",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___ko",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/ja/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___ja",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___ja",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___ja",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___ja",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/zh-hant/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___zh-hant",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___zh-hant",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___zh-hant",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___zh-hant",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___en___default",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___en___default",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___en___default",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___en___default",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/en/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___en",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___en",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___en",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___en",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/es/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___es",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___es",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___es",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___es",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/zh-CN/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___zh-CN",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___zh-CN",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___zh-CN",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___zh-CN",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/it/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___it",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___it",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___it",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___it",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/ru/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___ru",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___ru",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___ru",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___ru",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/vi/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___vi",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___vi",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___vi",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___vi",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/id/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___id",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___id",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___id",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___id",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/km/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___km",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___km",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___km",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___km",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/hi/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___hi",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___hi",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___hi",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___hi",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/th/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___th",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___th",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___th",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___th",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/fr/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___fr",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___fr",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___fr",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___fr",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: markets1Wulb56LB7Meta?.name,
    path: "/ar/markets",
    meta: markets1Wulb56LB7Meta || {},
    component: () => import("/app/src/pages/markets.vue").then(m => m.default || m),
    children: [
  {
    name: "markets-favorite___ar",
    path: "favorite",
    component: () => import("/app/src/pages/markets/favorite/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-futures___ar",
    path: "futures",
    component: () => import("/app/src/pages/markets/futures/index.vue").then(m => m.default || m)
  },
  {
    name: "markets___ar",
    path: "",
    component: () => import("/app/src/pages/markets/index.vue").then(m => m.default || m)
  },
  {
    name: "markets-spot___ar",
    path: "spot",
    component: () => import("/app/src/pages/markets/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___ko",
    path: "/ko/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___ko",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___ko",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___ko",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___ko",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___ko",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___ja",
    path: "/ja/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___ja",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___ja",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___ja",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___ja",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___ja",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___zh-hant",
    path: "/zh-hant/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___zh-hant",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___zh-hant",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___zh-hant",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___zh-hant",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___zh-hant",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___en___default",
    path: "/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___en___default",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___en___default",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___en___default",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___en___default",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___en___default",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___en",
    path: "/en/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___en",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___en",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___en",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___en",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___en",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___es",
    path: "/es/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___es",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___es",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___es",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___es",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___es",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___zh-CN",
    path: "/zh-CN/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___zh-CN",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___zh-CN",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___zh-CN",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___zh-CN",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___zh-CN",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___it",
    path: "/it/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___it",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___it",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___it",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___it",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___it",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___ru",
    path: "/ru/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___ru",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___ru",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___ru",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___ru",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___ru",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___vi",
    path: "/vi/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___vi",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___vi",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___vi",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___vi",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___vi",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___id",
    path: "/id/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___id",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___id",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___id",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___id",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___id",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___km",
    path: "/km/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___km",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___km",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___km",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___km",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___km",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___hi",
    path: "/hi/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___hi",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___hi",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___hi",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___hi",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___hi",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___th",
    path: "/th/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___th",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___th",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___th",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___th",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___th",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___fr",
    path: "/fr/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___fr",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___fr",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___fr",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___fr",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___fr",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "my___ar",
    path: "/ar/my",
    meta: myX0IidJ4wjZMeta || {},
    component: () => import("/app/src/pages/my.vue").then(m => m.default || m),
    children: [
  {
    name: "my-orders-future-type___ar",
    path: "orders/future/:type?",
    component: () => import("/app/src/pages/my/orders/future/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-orders-spot-type___ar",
    path: "orders/spot/:type?",
    component: () => import("/app/src/pages/my/orders/spot/[[type]].vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-future___ar",
    path: "wallet/future",
    component: () => import("/app/src/pages/my/wallet/future/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet___ar",
    path: "wallet",
    component: () => import("/app/src/pages/my/wallet/index.vue").then(m => m.default || m)
  },
  {
    name: "my-wallet-spot___ar",
    path: "wallet/spot",
    component: () => import("/app/src/pages/my/wallet/spot/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: "node-record___ko",
    path: "/ko/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___ja",
    path: "/ja/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___zh-hant",
    path: "/zh-hant/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___en___default",
    path: "/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___en",
    path: "/en/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___es",
    path: "/es/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___zh-CN",
    path: "/zh-CN/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___it",
    path: "/it/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___ru",
    path: "/ru/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___vi",
    path: "/vi/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___id",
    path: "/id/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___km",
    path: "/km/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___hi",
    path: "/hi/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___th",
    path: "/th/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___fr",
    path: "/fr/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "node-record___ar",
    path: "/ar/node/record",
    meta: indexMJaNOt3E4RMeta || {},
    component: () => import("/app/src/pages/node/record/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___ko",
    path: "/ko/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___ja",
    path: "/ja/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___zh-hant",
    path: "/zh-hant/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___en___default",
    path: "/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___en",
    path: "/en/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___es",
    path: "/es/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___zh-CN",
    path: "/zh-CN/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___it",
    path: "/it/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___ru",
    path: "/ru/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___vi",
    path: "/vi/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___id",
    path: "/id/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___km",
    path: "/km/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___hi",
    path: "/hi/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___th",
    path: "/th/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___fr",
    path: "/fr/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "partner___ar",
    path: "/ar/partner",
    meta: indexZZTBKuA4nFMeta || {},
    component: () => import("/app/src/pages/partner/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___ko",
    path: "/ko/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___ja",
    path: "/ja/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___zh-hant",
    path: "/zh-hant/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___en___default",
    path: "/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___en",
    path: "/en/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___es",
    path: "/es/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___zh-CN",
    path: "/zh-CN/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___it",
    path: "/it/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___ru",
    path: "/ru/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___vi",
    path: "/vi/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___id",
    path: "/id/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___km",
    path: "/km/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___hi",
    path: "/hi/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___th",
    path: "/th/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___fr",
    path: "/fr/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "privacy-portal___ar",
    path: "/ar/privacy-portal",
    meta: indexYt4ISFXuA2Meta || {},
    component: () => import("/app/src/pages/privacy-portal/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___ko",
    path: "/ko/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___ja",
    path: "/ja/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___zh-hant",
    path: "/zh-hant/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___en___default",
    path: "/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___en",
    path: "/en/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___es",
    path: "/es/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___zh-CN",
    path: "/zh-CN/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___it",
    path: "/it/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___ru",
    path: "/ru/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___vi",
    path: "/vi/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___id",
    path: "/id/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___km",
    path: "/km/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___hi",
    path: "/hi/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___th",
    path: "/th/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___fr",
    path: "/fr/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "referral___ar",
    path: "/ar/referral",
    meta: indexuwjnwDioWQMeta || {},
    component: () => import("/app/src/pages/referral/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___ko",
    path: "/ko/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___ja",
    path: "/ja/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___zh-hant",
    path: "/zh-hant/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___en___default",
    path: "/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___en",
    path: "/en/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___es",
    path: "/es/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___zh-CN",
    path: "/zh-CN/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___it",
    path: "/it/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___ru",
    path: "/ru/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___vi",
    path: "/vi/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___id",
    path: "/id/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___km",
    path: "/km/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___hi",
    path: "/hi/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___th",
    path: "/th/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___fr",
    path: "/fr/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "sign-up___ar",
    path: "/ar/sign-up",
    meta: indexYChQVes8pRMeta || {},
    component: () => import("/app/src/pages/sign-up/index.vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___ko",
    path: "/ko/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___ja",
    path: "/ja/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___zh-hant",
    path: "/zh-hant/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___en___default",
    path: "/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___en",
    path: "/en/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___es",
    path: "/es/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___zh-CN",
    path: "/zh-CN/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___it",
    path: "/it/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___ru",
    path: "/ru/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___vi",
    path: "/vi/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___id",
    path: "/id/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___km",
    path: "/km/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___hi",
    path: "/hi/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___th",
    path: "/th/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___fr",
    path: "/fr/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "spot-symbol___ar",
    path: "/ar/spot/:symbol?",
    meta: _91_91symbol_93_93Q7ccl8p29CMeta || {},
    component: () => import("/app/src/pages/spot/[[symbol]].vue").then(m => m.default || m)
  },
  {
    name: "terms___ko",
    path: "/ko/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___ja",
    path: "/ja/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___zh-hant",
    path: "/zh-hant/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___en___default",
    path: "/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___en",
    path: "/en/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___es",
    path: "/es/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___zh-CN",
    path: "/zh-CN/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___it",
    path: "/it/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___ru",
    path: "/ru/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___vi",
    path: "/vi/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___id",
    path: "/id/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___km",
    path: "/km/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___hi",
    path: "/hi/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___th",
    path: "/th/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___fr",
    path: "/fr/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "terms___ar",
    path: "/ar/terms",
    meta: indexP7iaSVhb9eMeta || {},
    component: () => import("/app/src/pages/terms/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___ko",
    path: "/ko/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___ja",
    path: "/ja/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___zh-hant",
    path: "/zh-hant/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___en___default",
    path: "/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___en",
    path: "/en/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___es",
    path: "/es/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___zh-CN",
    path: "/zh-CN/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___it",
    path: "/it/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___ru",
    path: "/ru/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___vi",
    path: "/vi/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___id",
    path: "/id/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___km",
    path: "/km/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___hi",
    path: "/hi/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___th",
    path: "/th/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___fr",
    path: "/fr/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply___ar",
    path: "/ar/token-listing-apply",
    meta: indexvxEWUpzYWmMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/index.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___ko",
    path: "/ko/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___ja",
    path: "/ja/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___zh-hant",
    path: "/zh-hant/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___en___default",
    path: "/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___en",
    path: "/en/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___es",
    path: "/es/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___zh-CN",
    path: "/zh-CN/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___it",
    path: "/it/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___ru",
    path: "/ru/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___vi",
    path: "/vi/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___id",
    path: "/id/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___km",
    path: "/km/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___hi",
    path: "/hi/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___th",
    path: "/th/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___fr",
    path: "/fr/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: "token-listing-apply-invite___ar",
    path: "/ar/token-listing-apply/invite",
    meta: invitetvbsJ1rEURMeta || {},
    component: () => import("/app/src/pages/token-listing-apply/invite.vue").then(m => m.default || m)
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/ko/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___ko",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/ja/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___ja",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/zh-hant/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___zh-hant",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___en___default",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/en/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___en",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/es/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___es",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/zh-CN/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___zh-CN",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/it/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___it",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/ru/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___ru",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/vi/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___vi",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/id/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___id",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/km/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___km",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/hi/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___hi",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/th/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___th",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/fr/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___fr",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: usermBqipyQ407Meta?.name,
    path: "/ar/user",
    meta: usermBqipyQ407Meta || {},
    component: () => import("/app/src/pages/user.vue").then(m => m.default || m),
    children: [
  {
    name: "user___ar",
    path: "",
    component: () => import("/app/src/pages/user/index.vue").then(m => m.default || m)
  }
]
  }
]